import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import styles from '../../styles.module.scss'

import { viewEvent } from '../../../utils'
import { action, serviceMap } from '../../../constants'
import { setServiceData } from '../../../../../../redux/billing/billing.action'

const EnhancedVisibilityHasExpired = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    viewEvent(action.hasExpired, serviceMap.enhancedVisibility)

    return () => {
      // set the data: {} after checking the service event,
      // so that there is no function getServiceData call, it should be called once, when initializing the application
      dispatch(setServiceData({ service: serviceMap.enhancedVisibility, data: {} }))
    }

    // eslint-disable-next-line
  }, [])

  return (
    <div className={styles.description}>
      <p className={styles.description_item}>Attention! VIP status subscription has expired.</p>
      <p>
        If you want your profile to continue to be among the first in the general list of sailors from the crew manager,
        please renew your subscription!
      </p>
    </div>
  )
}

export default EnhancedVisibilityHasExpired
